import { Box, Button, styled } from '@mui/material';

export const OverviewEntryContainer = styled(Box)(({ theme: t }) => ({
  display: 'flex',
  flex: 1,
  backgroundColor: 'white',
  borderRadius: t.borderRadius.md,
}));

export const OverviewContainer = styled(Box)(({ theme: t }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  alignItems: 'stretch',
  justifyContent: 'center',
  gap: t.spacing(2),
  minHeight: 80,
  borderRadius: t.borderRadius.md,
}));

export const ButtonStyled = styled(Button)(({ theme: t }) => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'stretch',
  textTransform: 'initial',
  fontWeight: 400,
  color: t.palette.text.primary,
  padding: t.spacing(2),
  cursor: 'pointer',
}));
